import { render, staticRenderFns } from "./emptyModal.vue?vue&type=template&id=071b96a9"
import script from "./emptyModal.vue?vue&type=script&lang=js"
export * from "./emptyModal.vue?vue&type=script&lang=js"
import style0 from "./emptyModal.vue?vue&type=style&index=0&id=071b96a9&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports